/**
 * Doelgroepen-slider.
 *
 * De slider schuift per kaart. Hij staat binnen de container, maar knipt niets af: de
 * kaarten ernaast lopen links en rechts door tot de vensterrand (zie audiences.scss).
 *
 * De balk eronder loopt vol vanaf links. Hij begint op het deel dat je in beeld hebt
 * (bij vier kaarten en 3,2 in beeld dus op 80%) en staat vol zodra je aan het eind bent.
 * Dat is iets anders dan Swipers eigen scrollbar, die een blokje heen en weer schuift.
 */

import Swiper from 'swiper/bundle';

export default function initAudiences() {
  document.querySelectorAll('.audiences__slider').forEach((slider) => {
    const root = slider.closest('.audiences');
    const fill = root ? root.querySelector('[data-audiences-fill]') : null;
    const controls = root ? root.querySelector('[data-audiences-controls]') : null;
    const prev = root ? root.querySelector('[data-audiences-prev]') : null;
    const next = root ? root.querySelector('[data-audiences-next]') : null;

    const paint = (swiper) => {
      if (! fill) {
        return;
      }

      // Het zichtbare deel van de totale breedte, plus wat er inmiddels langs is.
      const visible = swiper.virtualSize > 0 ? swiper.size / swiper.virtualSize : 1;
      const ratio = swiper.isEnd
        ? 1
        : Math.min(1, visible + (swiper.progress || 0) * (1 - visible));

      fill.style.width = `${(ratio * 100).toFixed(2)}%`;
    };

    // Passen alle kaarten in beeld, dan valt er niets te schuiven en is de hele rij
    // ruis: een balk die altijd vol staat en twee knoppen die niets doen. Op een breed
    // scherm met weinig doelgroepen -- een dienst met er maar twee bijvoorbeeld -- is
    // dat het normale geval, dus dit is geen randgeval maar de gewone toestand.
    const paintControls = (swiper) => {
      if (! controls) {
        return;
      }

      controls.hidden = swiper.isLocked || (swiper.isBeginning && swiper.isEnd);
    };

    const paintAll = (swiper) => {
      paint(swiper);
      paintControls(swiper);
    };

    // Afstand van de vensterrand tot de containerrand; de eerste kaart hoort daar te
    // beginnen. Verandert mee met het breekpunt, dus bij resize opnieuw meten.
    new Swiper(slider, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 32,
        },
      },
      // Swiper zet de knoppen zelf op swiper-button-disabled aan het begin en het eind.
      navigation: prev && next ? { prevEl: prev, nextEl: next } : false,
      // Swiper schrijft zijn eigen aria-label over de knoppen heen; zonder dit staat er
      // 'Previous slide' in een verder Nederlandse pagina.
      a11y: {
        prevSlideMessage: 'Vorige doelgroep',
        nextSlideMessage: 'Volgende doelgroep',
      },
      on: {
        init: paintAll,
        progress: paint,
        setTranslate: paint,
        resize: paintAll,
      },
    });
  });
}
